import { useState } from 'react';

export interface WeekOption {
  value: string;
  label: string;
}

export const useWeek = (initialWeek: string | null = null) => {
  const getWeekLabel = (value: string): string => {
    switch (value) {
      case '1':
        return 'Tuần thứ 1 của tháng';
      case '2':
        return 'Tuần thứ 2 của tháng';
      case '3':
        return 'Tuần thứ 3 của tháng';
      case '4':
        return 'Tuần thứ 4 của tháng';
      case '5':
        return 'Tuần thứ 5 của tháng';
      default:
        return 'Tuần thứ 1 của tháng';
    }
  };

  const [selectedWeek, setSelectedWeek] = useState<WeekOption | null>(
    initialWeek
      ? {
          value: initialWeek,
          label: getWeekLabel(initialWeek)
        }
      : {
          value: '1',
          label: 'Tuần thứ 1 của tháng'
        }
  );

  return {
    selectedWeek,
    setSelectedWeek
  };
};

export default useWeek;
